import { ENV } from '@/utils/env';
import { innovorderApi } from '../../index';
import { ApiRequest } from '../../request.types';
import {
    GetConfigPayload,
    CreateConfigPayload,
    PaygreenConfig,
    UpdateConfigPayload,
    DeleteConfigPayload,
    DeleteConfigResponse,
} from './configurations.type';

const configurationApi = innovorderApi.injectEndpoints({
    endpoints: (build) => ({
        getPaygreenConfig: build.query<PaygreenConfig, ApiRequest<GetConfigPayload>>({
            query: ({ restaurantId }) => {
                return {
                    url: new URL(`/v1/paygreen/configurations/restaurants/${restaurantId}`, ENV.PAYMENT_SERVICE_URL)
                        .href,
                    method: 'GET',
                    transformResponse: (response: PaygreenConfig) => {
                        return response.id ? response : undefined;
                    },
                    validateStatus: (response, result) => response.status < 400 || result.statusCode === 404,
                };
            },
            extraOptions: { maxRetries: 3 },
        }),
        createPaygreenConfig: build.mutation<PaygreenConfig, ApiRequest<CreateConfigPayload>>({
            query: ({ ...params }) => {
                return {
                    url: new URL('/v1/paygreen/configurations', ENV.PAYMENT_SERVICE_URL).href,
                    body: params,
                    method: 'POST',
                };
            },
            transformResponse: (response: PaygreenConfig) => response,
            extraOptions: { maxRetries: 3 },
        }),
        updatePaygreenConfig: build.mutation<PaygreenConfig, ApiRequest<UpdateConfigPayload>>({
            query: ({ configurationId, ...params }) => {
                return {
                    url: new URL(`/v1/paygreen/configurations/${configurationId}`, ENV.PAYMENT_SERVICE_URL).href,
                    body: params,
                    method: 'PATCH',
                };
            },
            transformResponse: (response: PaygreenConfig) => response,
            extraOptions: { maxRetries: 3 },
        }),
        deletePaygreenConfig: build.mutation<DeleteConfigResponse, ApiRequest<DeleteConfigPayload>>({
            query: ({ configurationId }) => {
                return {
                    url: new URL(`/v1/paygreen/configurations/${configurationId}`, ENV.PAYMENT_SERVICE_URL).href,
                    method: 'DELETE',
                };
            },
            transformResponse: (response: DeleteConfigResponse) => response,
            extraOptions: { maxRetries: 3 },
        }),
    }),
});

export const {
    useLazyGetPaygreenConfigQuery,
    useGetPaygreenConfigQuery,
    useCreatePaygreenConfigMutation,
    useUpdatePaygreenConfigMutation,
    useDeletePaygreenConfigMutation,
} = configurationApi;
